<div class="content__wrapper">
  @if (showSidebar) {
    <app-nav-menu
      [env]="environment"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      [userToken]="userToken"
      appTitle="Sierra Order"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }
  <div class="cs-shell">
    @if (showSidebar) {
      <csl-main-header />
    }
    <router-outlet />
  </div>
  <p-toast position="bottom-right" key="main" />
  <p-confirmdialog key="main" [draggable]="false" />
</div>
<csl-environment-indicator [envType]="environment" />
